<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M6.44128 2.64307H3.12959C2.86062 2.64307 2.64258 2.86111 2.64258 3.13008V6.44177C2.64258 6.71074 2.86062 6.92878 3.12959 6.92878H6.44128C6.71025 6.92878 6.92829 6.71074 6.92829 6.44177V3.13008C6.92829 2.86111 6.71025 2.64307 6.44128 2.64307Z"
                :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path
                d="M12.87 2.64307H9.5583C9.28933 2.64307 9.07129 2.86111 9.07129 3.13008V6.44177C9.07129 6.71074 9.28933 6.92878 9.5583 6.92878H12.87C13.139 6.92878 13.357 6.71074 13.357 6.44177V3.13008C13.357 2.86111 13.139 2.64307 12.87 2.64307Z"
                :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path
                d="M6.44128 9.07129H3.12959C2.86062 9.07129 2.64258 9.28933 2.64258 9.5583V12.87C2.64258 13.139 2.86062 13.357 3.12959 13.357H6.44128C6.71025 13.357 6.92829 13.139 6.92829 12.87V9.5583C6.92829 9.28933 6.71025 9.07129 6.44128 9.07129Z"
                :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path
                d="M12.87 9.07129H9.5583C9.28933 9.07129 9.07129 9.28933 9.07129 9.5583V12.87C9.07129 13.139 9.28933 13.357 9.5583 13.357H12.87C13.139 13.357 13.357 13.139 13.357 12.87V9.5583C13.357 9.28933 13.139 9.07129 12.87 9.07129Z"
                :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconGrid',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>